export const errorConstants = {
    /**
     * Error response returned by the backend when the client tries to use expires access token.
     */
    NOT_AUTHORIZED: 'not-authorized',

    /**
     * When backend receives an error response from which there is no recovery.
     */
    REQUEST_FAILED: 'request-failed'
};
